import React, { useState } from 'react'
import { IonPage, IonIcon, IonHeader, IonTextarea, useIonViewWillEnter, IonCard, IonAlert, IonToolbar, IonImg, IonBackButton, IonContent, IonText, IonItem, IonLabel, IonInput, IonButton, IonSelect, IonSelectOption } from '@ionic/react'
import { mailOutline } from "ionicons/icons"
import Loading from "../components/Loading";
import './Home.css';
import logoActive from "../assets/LogoActiveAnimated.gif";
import axios from 'axios'

function Contacto() {
  let [showAlert1, setShowAlert1] = useState(false);
  let [showAlert2, setShowAlert2] = useState(false);
  let [showAlert3, setShowAlert3] = useState(false);
  let [loading, setLoading] = useState(false)

  let [device, setDevice] = useState('formularioSmall')

  let [name, setName] = useState('')
  let [cel, setCel] = useState('')
  let [mail, setMail] = useState('')
  let [comments, setComments] = useState('')
  let [app, setApp] = useState('')

  function manda() {
    if (name === '' || cel === '' || mail === '' || comments === '' || app === '') { setShowAlert2(true) }

    else {
      setLoading(true)

      let mensaje =
        `
        <html>
        <head>
        <style>        
          h1 {text - align: center;}
          .img-container {margin: auto; width: 30%; border-radius: 30%; }
        </style>
        </head>
        
        <body>
        <img class="img-container" alt="Logo" src="https://res.cloudinary.com/activecode/image/upload/w_1000,ar_1:1,c_fill,g_auto,e_art:hokusai/v1656874398/Logo.jpg" />
         
        <br>

        <h2>${app}</h2>
        <h2>Nombre: ${name}</h2>
        <h2>Telefono: ${cel}</h2>
        <h2>Email: ${mail}</h2>
        <br>
        <h2>${comments}</h2>
                
        </body>
        </html>                    
      `
      axios.post('https://supporpagetback.herokuapp.com/api/v1/send', { subject: `Support Page: ${app}`, messaje: mensaje })
        .then(() => { setLoading(false); setShowAlert1(true) })
        .catch((err) => { setLoading(false); setShowAlert3(true); console.log(err) })
    }
  }

  useIonViewWillEnter(() => {
    const { innerWidth: width, innerHeight: height } = window;

    if (width > 1000) { setDevice('formularioBig') }
  }, [])

  return (
    <>
      <IonPage>
        <IonContent className="ion-padding ion-text-center">
          <IonAlert
            isOpen={showAlert1}
            onDidDismiss={() => setShowAlert1(false)}
            header={'Informacion enviada con exito!'}
            buttons={['OK']}
          />

          <IonAlert
            isOpen={showAlert2}
            onDidDismiss={() => setShowAlert2(false)}
            header={'Debes llenar todos los campos'}
            buttons={['OK']}
          />

          <IonAlert
            isOpen={showAlert3}
            onDidDismiss={() => setShowAlert3(false)}
            header={'Ocurrio un error, intenta de nuevo por favor'}
            buttons={['OK']}
          />

          <div className={device}>
            <IonImg className='logoActive' src={logoActive} alt={"Active Code"} />

            <br />

            <IonCard color='title'><p id='screenTitles'>CONTACTO DE SOPORTE</p></IonCard>

            <br /><br />

            <IonText className='fuente'>Si tienes alguna duda o comentarios, por favor contactanos llenando el siguiente formulario</IonText>

            <br /><br /><br />

            <form>
              <input type="hidden" name="_captcha" value="false"></input>

              <IonItem>
                <IonLabel position="floating">App</IonLabel>
                <IonSelect interface="popover" onIonChange={(e) => { setApp(e.target.value) }}>
                  <IonSelectOption className="select" value="Tebila App">Tebila App</IonSelectOption>
                  <IonSelectOption className="select" value="Calendario Ateret Yosef">Calendario Ateret Yosef</IonSelectOption>
                  <IonSelectOption className="select" value="Jebra Kadisha Maguen David">Jebra Kadisha Maguen David</IonSelectOption>
                  <IonSelectOption className="select" value="100 Berajot al Día">100 Berajot al Día</IonSelectOption>
                  <IonSelectOption className="select" value="Omer">Omer</IonSelectOption>
                  <IonSelectOption className="select" value="Tutorah.tv">Tutorah.tv</IonSelectOption>
                  <IonSelectOption className="select" value="Bus YKT">Bus YKT</IonSelectOption>
                  <IonSelectOption className="select" value="Jevrá Kedoshá Comunidad Sefaradi">Jevrá Kedoshá Comunidad Sefaradi</IonSelectOption>
                </IonSelect>
              </IonItem>

              <IonItem>
                <IonLabel position="floating">Nombre</IonLabel>
                <IonInput value={name} type='text' name="Nombre" required='true' onIonChange={e => { setName(e.target.value) }}></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="floating">Telefono</IonLabel>
                <IonInput value={cel} type='number' name="Celular" required='true' onIonChange={e => { setCel(e.target.value) }}></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="floating">Email</IonLabel>
                <IonInput value={mail} type='text' name="Email" required='true' onIonChange={e => { setMail(e.target.value) }}></IonInput>
              </IonItem>

              <br /><br />

              <IonItem>
                <IonTextarea value={comments} placeholder="Comentarios" name='Mensaje' required='true' rows='5' onIonChange={e => { setComments(e.target.value) }}></IonTextarea>
              </IonItem>

              <br /><br />

              {loading ? <Loading /> : <IonButton color='background' onClick={manda}><IonIcon slot="start" icon={mailOutline} />Enviar</IonButton>}
            </form>
          </div>

          <br /><br />

        </IonContent>
      </IonPage>
    </>
  )
}

export default Contacto